import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { Row, Col, Image } from "react-bootstrap";

//ACTIONS
import * as GS_generalSettingsActions from "../../store/actions/globalSettings/GS_generalSettings";
import * as NavBarActions from "../envStore/actions/navBar";

//STYLES
import * as UserRouteSystemStyles from "./styles/userRouteSystem";

//ACTIONS
import * as UserActions from "../../store/actions/user";

//USER SIDE
import Home from "./files/home";
import PageView from "./files/pageView";
import EditorialView from "./files/editoralView";

//FROM ADMIN CORE SIDE
import AdminBanner from "../../administration/pods/adminBanner/adminBanner";
// import FrontEndMainContact from "../../administration/pods/contacts/files/frontEndMainContact";
import SiteOffline from "../../administration/pods/siteOffline/files/siteOffline";

// import MembershipExtra from "../pods/membershipExtra/mainFiles/frontEnd/podRouter";

function UserRouteSystem() {
    const user = useSelector((state) => state.user);
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        onOpen();
        if (window.innerWidth < 740) {
            dispatch(GS_generalSettingsActions.UpdateIsMobile(true));
        } else {
            dispatch(GS_generalSettingsActions.UpdateIsMobile(false));
        }

        window.addEventListener("resize", (event) => {
            if (event.target.innerWidth < 740) {
                dispatch(GS_generalSettingsActions.UpdateIsMobile(true));
            } else {
                dispatch(GS_generalSettingsActions.UpdateIsMobile(false));
            }
        });
    }, []);

    function onOpen() {
        Axios.post("/pods/userRouter/getOpeningData")
            .then((res) => {
                const data = res.data;
                console.log(data);
                dispatch(GS_generalSettingsActions.UpdateMainContactPageVisible(data.settings.mainContactPage.value == "true"));
                dispatch(GS_generalSettingsActions.UpdateSiteOffline(data.settings.siteOffline.value == "true"));
                dispatch(GS_generalSettingsActions.UpdateSiteOfflineMessage(data.settings.siteOffline.subValue));
                console.log(data.backgroundImages);
                dispatch(NavBarActions.UpdateBackgroundImages(data.backgroundImages));

                if (user.auth && user.type !== "registered") {
                    dispatch(UserActions.UpdateAdminSignedIn(true));
                }

                //MEMBERSHIP EXTRA POD
                if (user.requestedPassword) {
                    navigate("/membership/changePassword");
                }

                setIsLoaded(true);
            })
            .catch((err) => console.log(err));
    }

    function offlineUserCheck(role) {
        if (role == "modifier" || role == "registered" || role == "") {
            return false;
        } else {
            return true;
        }
    }

    return (
        <div>
            {isLoaded && (
                <div>
                    {/* && !offlineUserCheck(user.type) */}
                    {GS_generalSettings.offline ? (
                        <div>
                            <SiteOffline />
                        </div>
                    ) : (
                        <div style={UserRouteSystemStyles.body}>
                            {user.adminSignedIn ? <AdminBanner /> : null}
                            <Routes>
                                <Route path="/page/:pageNav/:pageID" element={<PageView scroll />} />
                                <Route path="/editorial/:pageNav/:editorialUUID" element={<EditorialView />} />
                                <Route path="/*" exact element={<Home />} />
                            </Routes>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default UserRouteSystem;
